import React, { useEffect, useState } from 'react';
import { Button, Modal, Icon, Tab, TabPane, Progress, Loader } from 'semantic-ui-react';
import agent from '../../app/api/agent';
import DynamicTableComponent from '../DynamicTable/DynamicTableComponent';
import { v4 as uuid } from 'uuid';
import { useStore } from '../../app/stores/store';

const MepzDataSync = () => {
  const [open, setOpen] = useState(false);
  const [showProgress, setShowProgress] = useState(false);
  const [loading, setLoading] = useState(false);
  const { dashboardStore, activityStore,userStore } = useStore();
  const [postsPerPage] = useState<number>(5);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [activeTabIndex, setActiveTabIndex] = useState<number>(0);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    fetchData(pageNumber, postsPerPage, activeTabIndex);
    // eslint-disable-next-line
  }, [pageNumber, postsPerPage, activeTabIndex]);

  const fetchData = async (pageNumber: number, pageSize: number, tabIndex: number) => {
    setLoading(true);
    try {
      if (tabIndex === 0) {
        // Fetch data for 'Un-Synced File' tab
        await activityStore.fetchMepzUnsyncedActivities(pageNumber, pageSize);
      } else if (tabIndex === 1) {
        // Fetch data for 'Synced File' tab
        await activityStore.fetchMepzsyncedActivities(pageNumber, pageSize);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  const paginateFunction = (pageNumber: number) => {
    fetchData(pageNumber, postsPerPage, activeTabIndex);
    dashboardStore.setTagPageNumFunc(pageNumber);
    setPageNumber(pageNumber);
  };

  const searchFunction = (column: any, order: any) => {
    console.log(column, order);
  };

  const handleTabChange = (e: any, { activeIndex }: any) => {
    setActiveTabIndex(activeIndex);
    fetchData(1, postsPerPage, activeIndex);
  };

  const panes = [
    { menuItem: 'Un-Synced File', render: () => (
        <TabPane style={{ overflow: 'auto' }}>
          <DynamicTableComponent
            key={uuid()}
            data={dashboardStore.dashboard.unSyncedData} // Use unSyncedData for 'Un-Synced File'
            name={'UnSyncTable'}
            actiontype={''}
            pageFunc={paginateFunction}
            pageNumData={pageNumber}
            searchFuncData={searchFunction}
          />
        </TabPane>
      )
    },
    { menuItem: 'Synced File', render: () => (
      <TabPane style={{ overflow: 'auto' }}>
        <DynamicTableComponent
          key={uuid()}
          data={dashboardStore.dashboard.syncedData} // Use syncedData for 'Synced File'
          name={'SyncTable'}
          actiontype={''}
          pageFunc={paginateFunction}
          pageNumData={pageNumber}
          searchFuncData={searchFunction}
        />
      </TabPane>
    )
  },
  ];

  const handleSync = async () => { 
    setOpen(false)
    setShowProgress(true); 
    try {
      await agent.Mepz.MepzSync();
      await activityStore.fetchMepzUnsyncedActivities(pageNumber, 5);
    } catch (error) {
      console.error('Error syncing data:', error);
    } finally {
      setShowProgress(false); 
    }
  };

  return (
    <>
      <div style={{ textAlign: 'right', padding: '0px 50px', marginTop: '30px' }}>
        <Button primary onClick={handleOpen} style={{ marginLeft: '50px' }}>
          <Icon name='sync' /> Bulk Sync
        </Button>
      </div>
      {showProgress ? (
        <div style={{ padding: '10px 50px', textAlign: 'center' }}>
          <Progress
            active
            size='medium'
            indicating
            percent={100}
            style={{ marginTop: '20px', backgroundColor: '#f0f0f0', color: '#00bfff' }}
          />
          <p>Syncing data, please wait...</p>
        </div>
      ) : loading ? (
        <div style={{ padding: '10px 50px', textAlign: 'center' }}>
          <Loader active inline='centered' />
          <p>Loading data...</p>
        </div>
      ): userStore.user?.customerName !== 'TNCA' ? (
        // Only render the Tab component if customerName is not 'TNCA'
        <Tab
          panes={panes}
          style={{ padding: '10px 50px' }}
          onTabChange={handleTabChange}
          activeIndex={activeTabIndex} // Ensure the active index is properly managed
        />
      ):null }
      <Modal
        open={open}
        onClose={handleClose}
        size='small'
      >
        <Modal.Header>Sync Data</Modal.Header>
        <Modal.Content>
          <p>Are you sure you want to sync the data?</p>
        </Modal.Content>
        <Modal.Actions>
          <Button
            positive
            onClick={handleSync}
          >
            <Icon name='checkmark' /> Yes
          </Button>
          <Button onClick={handleClose} negative>
            <Icon name='close' /> No
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};

export default MepzDataSync;